export default class ChatBotProvedorComunicacaoEnum {
    static WhatsApp = 1
    static MetaMessenger = 2
}
